/*
 * File: /src/pages/install/install-payment.vue
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Monday, 16th July 2018 2:57:21 pm
 * Last Modified: Wed May 22 2019
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
<template>
    <p class="install-msg">
        Payment in progress
    </p>
</template>
<script>
import { logger, isShopifyEmbedded } from '@/helpers'

export default {
    methods: {
        inIframe() {
            try {
                return isShopifyEmbedded()
            } catch (e) {
                return true
            }
        }
    },
    async mounted() {
        let redirectInt

        try {
            const { confirmation_url } = await this.$store.dispatch('shop/CHARGE_CREATE')

            if (this.inIframe()) {
                redirectInt = setInterval(() => {
                    const ready = this.$store.getters['shopifyBar/ready']

                    if (ready && window.shopify) {
                        clearInterval(redirectInt)
                        logger('window.open confirmation_url', { confirmation_url })
                        // For payment/OAuth redirects in embedded apps
                        // window.top.location.href fails due to cross-origin security restrictions
                        // Use window.open with _top to navigate the parent window
                        window.open(confirmation_url, '_top')
                    }
                }, 2000)
            } else {
                logger('window.location = confirmation_url', { confirmation_url })
                window.location = confirmation_url
            }
        } catch (error) {
            console.error(`Couldn't get payment redirect url`, error)
            clearInterval(redirectInt)
            this.$router.push({ name: 'error' })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/install/install-payment.vue